import { ReactNode, useRef } from 'react'
import { BottomSheet, BottomSheetRef } from 'react-spring-bottom-sheet'
import { getBottomPadding } from '../../utils/sessionStorage'
import Button from '../ui-components/Button'
import './PeersSheet.css'

type PeersSheetProps = {
  isOpen: boolean
  onClose: () => void
  header?: ReactNode
  footer?: ReactNode
  children: ReactNode
}

export default function PeersSheet({ isOpen, onClose, header, footer, children }: PeersSheetProps) {
  const sheetRef = useRef<BottomSheetRef>(null)
  return (
    <BottomSheet
      open={isOpen}
      onDismiss={onClose}
      ref={sheetRef}
      header={header}
      footer={footer ?? <PeersSheetCloseFooter onClose={onClose} />}
      snapPoints={({ minHeight, maxHeight }) => [minHeight, maxHeight * 0.9]}
      defaultSnap={({ snapPoints }) => Math.min(...snapPoints)}
      className='peers-sheet'
    >
      {children}
    </BottomSheet>
  )
}

export function PeersSheetCloseFooter({ onClose }: { onClose: () => void }) {
  return (
    <div style={{ paddingBottom: `${getBottomPadding() + 4}px` }} className='w-full bg-white z-[99] h-max'>
      <Button isFullWidth onClick={onClose} buttonClassName='w-full bg-white h-max px-[2px]'>
        <div className='border border-[#D1D6D6] w-full rounded-xl flex items-center justify-center px-6 pt-[15px] pb-4 text-[15px] text-[#232323] font-[500]'>
          Close
        </div>
      </Button>
    </div>
  )
}
